import { andVobFilter } from '@iotv/core-services';
import { VideoHubClassName, VideoStreamClassName, getChildEdgeTypeId } from '@iotv/datamodel-core';
import { TypeIcons } from '../../../Iconography';
import { AdjacentType } from '../../../types';
export const getCustomerVideoHubPath = ({ filters }) => {
    const apexQuery = {
        nodeFilter: andVobFilter(filters),
        renderTypeFolder: false,
        hideThisStep: false,
        stepQuery: {
            objectTypeId: VideoHubClassName,
            adjacencyType: AdjacentType.CHILD,
            edgeTypeId: getChildEdgeTypeId('Customer', 'VideoHub'),
        },
        endIcon: TypeIcons.VideoHub,
        nextSteps: [
            {
                nodeFilter: andVobFilter(filters),
                renderTypeFolder: false,
                hideThisStep: false,
                stepQuery: {
                    objectTypeId: VideoStreamClassName,
                    adjacencyType: AdjacentType.CHILD,
                    edgeTypeId: getChildEdgeTypeId('VideoHub', 'VideoStream'),
                },
                endIcon: TypeIcons.Camera,
            }
        ],
    };
    return apexQuery;
};
const customerVideoHubPath = getCustomerVideoHubPath({ filters: [] });
export { customerVideoHubPath };
